import styled from '@emotion/styled'
import React from 'react'

import { FixedAspectBox } from 'components/util/FixedAspectBox'

const VideoPlayer = ({ title, channelLink, ...passThrough }) => (
  <VideoContainer>
    {title && <div className="title">{title}</div>}
    <FixedAspectBox relativeWidth={16} relativeHeight={9}>
      <iframe
        style={{ height: '100%', width: '100%', border: 0, borderRadius: 8 }}
        src={
          passThrough.url.replace(
            'https://youtu.be/',
            'https://youtube.com/embed/',
          ) + '?rel=0'
        }
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title={title}
      />
    </FixedAspectBox>
    {channelLink && (
      <a
        className="channelLink"
        href="https://www.youtube.com/c/visakingsglobal"
        target="_blank"
        rel="noreferrer"
      >
        Visit our YouTube channel!
      </a>
    )}
  </VideoContainer>
)

const VideoContainer = styled.div`
  margin-top: 24px;
  margin-bottom: 24px;
  .title {
    font-weight: 600;
    text-align: center;
    margin-bottom: 10px;
  }

  .channelLink {
    display: block;
    margin-top: 8px;
    font-weight: 600;
    font-size: 1.4rem;
    opacity: 0.8;

    &:hover {
      opacity: 1;
    }
  }
`

export default VideoPlayer
